// extracted by mini-css-extract-plugin
export default {"dateCell":"styles_dateCell__EqXXS","dateUpdated":"styles_dateUpdated__UqhUw","wrapper":"styles_wrapper__dZvdd","dateUpdatedText":"styles_dateUpdatedText__j9lrI"};